<template>
  <div class="row h-100 mt-7">
    <div class="col-md-4 h-100">
      <div >
        <ActionsBar :query="query" :types="types"/>
      </div>
      <div style="height: calc(100% - 55px)">
        <DiscussionListCard
            :module-id="moduleId"
            :module-class="moduleClass"
            :query="query"
            @toggle-conversation="toggleConversation"
            :loading="loadingConversation"
        />
      </div>
    </div>
    <div class="col-md-8 h-100">
      <DiscussionViewCard v-if="query.conversation" :query="query" :startCall="makeCall" @close-conversation="closeConversation"/>
      <EmptyDiscussion v-else/>
    </div>
  </div>
</template>

<script setup>

import DiscussionListCard from "@/Modules/Chat/components/DiscussionListCard.vue";
import ActionsBar from "@/Modules/Chat/components/ActionsBar.vue";
import EmptyDiscussion from "@/Modules/Chat/components/EmptyDiscussion.vue";
import DiscussionViewCard from "@/Modules/Chat/components/DiscussionViewCard.vue";

import {computed, onMounted, ref, watch} from "vue";
import {MEET_DOMAIN} from "@/services/meetService";
import {normaliserTexte} from "@/mixins/Helpers";
import {useStore} from "vuex";
import {useLocales} from "@/composables/locales";

const store = useStore()
const {locale} = useLocales()

const props = defineProps({
  id: {type: String, default: ''},
  moduleClass: {type: String, default: ''},
  moduleId: {type: String, default: ''}
})

const query = ref({
  type: 'all',
  search: '',
  conversation: ''
})

const types = ref([
  { title: 'Tous', fr: 'Tous', en: 'Tous', value: 'all' },
  { title: 'Canal', fr: 'Canal', en: 'Canal', value: 'canal' },
  { title: 'Discussion', fr: 'Discussion', en: 'Discussion', value: 'disc' },
])

const jitsi = ref(null)
const callWindow = ref(null)
const currentCall = ref(null)

const loadingConversation = ref(false)

const currentConversation = computed(() => store.getters['chat/getConversation'](query.value.conversation))
const currentUser = computed(() => store.getters['user/currentUser'])


watch(() => props.module, () => {

})

watch(() => currentUser.value, () => {
  eventSubscription()
})



function toggleConversation(conversationId) {
  query.value.conversation = conversationId
}

const makeCall = () => {
  const roomName = normaliserTexte(currentConversation.value.name)
  const link = `https://${MEET_DOMAIN}/${roomName}`;
  const windowFeatures = "width=800,height=600,resizable=yes,scrollbars=no";
  callWindow.value = window.open("", "callWindow", windowFeatures);

  if (callWindow.value) {
    callWindow.value.document.write(`
      <!DOCTYPE html>
      <html lang="fr">
      <head>
        <title>Appel Vidéo ${roomName}</title>
      </head>
      <body style="margin: 0; overflow: hidden;">
        <div id="meet" style="width: 100vw; height: 100vh;"></div>
      </body>
      </html>
    `);
    callWindow.value.document.close();


    const script = callWindow.value.document.createElement("script");
    script.src = `https://${MEET_DOMAIN}/external_api.js`;
    const meetOption = {
      locale: locale.value,
      displayName: currentUser.value?.fullname
    }
    script.onload = () => initializeJitsi(callWindow.value, roomName, meetOption);
    callWindow.value.document.head.appendChild(script);
  }

  store.dispatch('chat/startCall', {
    conversation_id: currentConversation.value.id,
    link
  })
      .then(res => {
        currentCall.value = res.data.data;
        if (!callWindow.value || callWindow.value.closed) {
          console.error("La fenêtre d'appel n'a pas pu être ouverte.");
          return;
        }
      })
      .catch(err => {
        console.error("Erreur lors de l'initialisation de l'appel :", err);
      });
};

const initializeJitsi = (callWindow, roomName, configs) => {
  const meetContainer = callWindow.document.getElementById("meet");
  if (!meetContainer) {
    console.error("Impossible de trouver #meet dans la fenêtre d'appel.");
    return;
  }

  const options = {
    userInfo: {
      displayName: configs.displayName || '',
    },
    parentNode: meetContainer,
    roomName: roomName,
    devices: ['audio', 'video'],
    configOverwrite: {
      prejoinPageEnabled: false,
    },
    lang: configs.locale,
    width: "100%",
    height: "100%"
  };

  jitsi.value = new callWindow.JitsiMeetExternalAPI(MEET_DOMAIN, options);

  jitsi.value.addEventListener('readyToClose', stopCall);
};

const stopCall = () =>  {
  store.dispatch('chat/stopCall', {
    id: currentCall.value.id,
    conversation_id: route.params.id
  })
      .then(() => {
        if(callWindow.value) {
          callWindow.value.close()
          callWindow.value = null
        }
        jitsi.value?.removeListener('readyToClose', () => {})
        jitsi.value?.dispose();
      })
}

const eventSubscription = () => {
  store.dispatch('chat/listenNewConversationEvent')
}

function loadConversation () {
  loadingConversation.value = true
  if(props.moduleId && props.moduleClass) {
    const payload = {
      module_id: props.moduleId,
      module_class: props.moduleClass,
    }
    store.dispatch('chat/loadConversations', payload)
        .finally(() => loadingConversation.value = false)
  }else {
    store.dispatch('chat/loadConversations')
        .finally(() => loadingConversation.value = false)
  }
}

function closeConversation() {
  query.value.conversation = ''
}

onMounted(() => {

  store.commit('chat/CHAT_RESET', false, { root: true })
  loadConversation()
})


</script>

<style scoped>

</style>